import { ErrorMessage, Field } from "formik";
import { CardBody, CardHeader, Col, FormGroup, Row } from "reactstrap";
import { useTranslation } from "react-i18next";

interface OrganizationAdminSectionProps {
  isEdit?: boolean;
}

const OrganizationAdminSection = ({ isEdit }: OrganizationAdminSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4">
      <CardHeader>
        <h5>{t("OrganizationAdminDetails")}</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col sm="4">
            <FormGroup>
              <label>{t("OrganizationContactPerson")} <span className="txt-danger">*</span></label>
              <Field
                name="contactPerson"
                type="text"
                className="form-control"
                placeholder={t("OrganizationContactPersonPlaceholder")}
              />
              <ErrorMessage
                name="contactPerson"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>
          <Col sm="4">
            <FormGroup>
              <label>{t("OrganizationMobile")} <span className="txt-danger">*</span></label>
              <Field
                name="mobileNumber"
                type="tel"
                className="form-control"
                placeholder={t("OrganizationMobilePlaceholder")}
              />
              <ErrorMessage
                name="mobileNumber"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>
          <Col sm="4">
            <FormGroup>
              <label>{t("OrganizationEmail")} <span className="txt-danger">*</span></label>
              <Field
                name="email"
                type="email"
                className="form-control"
                placeholder={t("OrganizationEmailPlaceholder")}
              />
              <ErrorMessage
                name="email"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </div>
  );
};

export default OrganizationAdminSection; 